"use client";

import { buildCheckoutData, pushData } from "@lib/analytics/events";
import FrameConfigContext from "@lib/contexts/frame_config";
import Session from "@lib/session";
import { useContext, useEffect } from "react";

export default function PushToDataLayer() {
  const { loading } = useContext(FrameConfigContext);

  useEffect(() => {
    if (loading) return;

    // Build cart data if available (has active legs with services)
    const booking = Session.getBooking();
    const checkoutData = buildCheckoutData(booking);

    if (checkoutData) {
      // Include ecommerce data for GTM consistency with begin_checkout event
      pushData({ ecommerce: checkoutData });
    } else {
      pushData();
    }
  }, [loading]);

  return null;
}
